// import { AuthenticationProvider } from "./components/AuthenticationProvider";

import { Provider } from 'react-redux';
import { I18nextProvider } from "react-i18next";

import RouterProvider from './routes';
import { ThemeProvider } from '@mui/material/styles';
import SettingsProvider from './components/Settings/components/SettingsProvider';

import { i18n } from './config';

import theme from './overrides/theme';
import store from './store';


import API from './services/api';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import SentryProvider from './components/Sentry/sentry';

const queryClient = new QueryClient();

const App = (props) => {
  API.init();
  
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <SettingsProvider>
          <SentryProvider>
            <ThemeProvider theme={theme}>
              <I18nextProvider i18n={i18n}> 
                <RouterProvider />
              </I18nextProvider>
            </ThemeProvider>
          </SentryProvider>
        </SettingsProvider>
      </Provider>
    </QueryClientProvider>
  );
};

export default App;
